/* Layout */
import Layout from '@/layout'

export default {
  path: '/system',
  component: Layout,
  redirect: '/system/user',
  name: 'system',
  meta: { title: '系统设置', icon: 'permission' },
  children: [
    {
      path: 'city',
      name: 'city',
      component: () => import('@/views/system/city/index'),
      meta: { title: '省市级联', icon: 'setting' }
    }
  ]
}
